import { Component, OnInit, AfterViewInit } from '@angular/core';


@Component({
  selector: 'app-coega-development-foundation',
  templateUrl: './coega-development-foundation.component.html',

})
/** coega-development-foundation component*/
export class CoegaDevelopmentFoundationComponent {


  scrollTimer: any;

  constructor() {



  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
  }

}
